import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANG, resolveLang, SUPPORTED_LANGS } from './resolveLang';
import ru from './resources/ru.json';
import uzCyrl from './resources/uz-Cyrl.json';
import uzLatn from './resources/uz-Latn.json';

export const resources = {
  ru: { translation: ru },
  'uz-Latn': { translation: uzLatn },
  'uz-Cyrl': { translation: uzCyrl },
};

/**
 * Инициализация синхронная, ресурсы — в бандле (не подгружаются по HTTP).
 * Это важно: ErrorPage (react-router errorElement) тоже переведён, а он
 * рендерится ровно тогда, когда что-то уже пошло не так — асинхронной
 * загрузке там доверять нельзя.
 *
 * keySeparator/nsSeparator выключены: ключи плоские, точка в 'form.title' —
 * часть имени, а не вложенность.
 */
i18n.use(initReactI18next).init({
  resources,
  lng: resolveLang(window.location.search),
  fallbackLng: DEFAULT_LANG,
  supportedLngs: [...SUPPORTED_LANGS],
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
});

export default i18n;
